




































































import { Search } from '@/data/models/search.model';
import { CrudService } from '@/data/services/crud.service';
import { ClassType } from 'class-transformer/ClassTransformer';
import { Component, Inject, Prop, Vue } from 'vue-property-decorator';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { User, UserType } from '@/data/models/user.model';
import store,{ State } from '@/store';

@Component({
	components: {
		ValidationObserver,
		ValidationProvider
	}
})
export default class CampagnaContattiOperatore extends Vue{
	@Inject('CrudService') opertatorCrudService !: CrudService<User>;

	@Prop() entity!: string;
	@Prop() redirect!: string;
	@Prop() assign!: boolean;

	advancedSearch = new Search('user');
	userSelected: User | null = null;
	userClass: ClassType<User> = User;

	state!: State;

	constructor() {
		super();
		this.state = store;
		this.advancedSearch.addSimpleFilter('hqid', this.state.headquarter!.id);
		this.advancedSearch.addSimpleFilter('utype', UserType.CALL_CENTER);
	}
	
	submit() {
		this.$emit('submit', this.userSelected);
	}

}
